/**
 * Possible states for any Order
 */
export enum StateModel {
	Queued = 'Queued',
	UnderReview = 'UnderReview',
	Approved = 'Approved',
	Rejected = 'Rejected',
	ReOpen = 'ReOpen',
	RevisionReceived = 'RevisionReceived',
	Cancelled = 'Cancelled'
}

/**
 * Labeled State Status
 */
export enum StatusModel {
	Queued = 'Queued',
	UnderReview = 'In Quality',
	Approved = 'Approved',
	Rejected = 'Returned for Revision',
	ReOpen = 'In Quality',
	RevisionReceived = 'Revision Received',
	Cancelled = 'Cancelled'
}

export enum SSRFILTEROPTION {
	SSR = 'With SSR rules',
	NOSSR = 'Without SSR rules'
}

export const ORDERSTATES = [
	{ id: 1, name: StateModel.Queued },
	{ id: 2, name: StateModel.UnderReview },
	{ id: 3, name: StateModel.Rejected },
	{ id: 4, name: StateModel.RevisionReceived },
	{ id: 5, name: StateModel.Approved },
	{ id: 6, name: StateModel.ReOpen },
	{ id: 7, name: StateModel.Cancelled }
];

// Default value for status orders
export const DEFAULTORDERSTATE = [
	{ id: 1, name: StateModel.Queued },
	{ id: 2, name: StateModel.UnderReview },
	{ id: 3, name: StateModel.Rejected },
	{ id: 4, name: StateModel.RevisionReceived },
	{ id: 5, name: StateModel.Approved }
];

export const FILTERSSROPTIONS = [
	{ id: true, name: SSRFILTEROPTION.SSR },
	{ id: false, name: SSRFILTEROPTION.NOSSR }
];

export const FORMFILTERLIST = [
	{id: 1, name: '1004' },
	{id: 2, name: '1073' },
	{id: 3, name: '1075' },
	{id: 4, name: '2055' }
];